import {
  arbitrum,
  avalanche,
  b3,
  base,
  blast,
  bsc,
  linea,
  mainnet,
  optimism,
  polygon,
  scroll,
} from 'viem/chains';
import { mockBtcEvmChainId } from '../config/btc';
import { mockSolEvmChainId } from '../config/sol';
import { Web3Type } from '../config/type';
import { IWeb3ChainType } from '../providers/web3Provider/type';

export const findSwapChainName = (chainId: number | undefined) => {
  switch (chainId) {
    case mainnet.id:
      return 'ETH';
    case bsc.id:
      return 'BSC';
    case arbitrum.id:
      return 'ARBITRUM';
    case optimism.id:
      return 'OPTIMISM';
    case base?.id:
      return 'BASE';
    case polygon.id:
      return 'POLYGON_POS';
    case blast.id:
      return 'BLAST';
    case avalanche.id:
      return 'AVAX';
    case scroll.id:
      return 'SCROLL';
    case linea.id:
      return 'LINEA';
    case b3.id:
      return 'B3';
    case mockBtcEvmChainId:
      return 'BITCOIN';
    case mockSolEvmChainId:
      return 'SOLANA';
    default:
      return '';
  }
};

export const filterSwapChainId = (chain: IWeb3ChainType | undefined) => {
  switch (chain?.type) {
    case 'EVM':
      return findSwapChainName(chain.chain?.id);
    case 'SOL':
      return 'SOLANA';
    case Web3Type.BTC:
      return 'BITCOIN';
    default:
      return undefined;
  }
};
